var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconError2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_1272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5917 2.29099L31.9997 20.884C25.8027 14.689 19.6037 8.48799 13.4057 2.29099C6.23574 -4.87901 -4.87826 6.23899 2.28574 13.411C8.48474 19.604 14.6857 25.806 20.8777 32.003C14.6829 38.2028 8.48557 44.4002 2.28574 50.595C-4.87826 57.763 6.23674 68.878 13.4057 61.715C19.6027 55.516 25.8017 49.316 31.9987 43.121L50.5907 61.715C57.7607 68.883 68.8777 57.764 61.7107 50.595C55.5117 44.396 49.3147 38.199 43.1137 32.001C49.3137 25.802 55.5107 19.603 61.7107 13.405C68.8787 6.23898 57.7617 -4.87901 50.5907 2.29499",
    fill: "#EC1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_1272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError2);
export default __webpack_public_path__ + "static/media/Icon-Error2.a07e2cad96831fa78d9e2e41ca602f3f.svg";
export { ForwardRef as ReactComponent };